import { style } from "@vanilla-extract/css";

export const selectGroup = style({
  display: "flex",
  flexDirection: "row",
  width: "100%"
});
